import InnerComponent from '@Components/Inventory/DeliveryChallan/ListDeliveryChallans';
import orgContainer from '@Components/AppContainer';

const ListDeliveryChallans = () => ((orgContainer(InnerComponent)));
export default ListDeliveryChallans;
